export default "__VITE_ASSET__X2rW78$p__"